/*
 * @Author: fang.lijuan
 * @Date: 2017-12-08
 * @LastEditTime : 2020-01-09 17:40:30
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\networkResource\featuredResource\left\left.js
 * @Description: 特色资源左侧
 */

'use strict';
angular.module('featuredResourceLeftModule', []).directive('featuredResourceLeft', [
    function() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                selectedParent: '=',
            },
            templateUrl: './networkResource/featuredResource/left/left_tpl.html',
            link: function() {},
        };
    },
]);
